var render, staticRenderFns
import script from "./home-tag-based-entry.vue?vue&type=script&lang=js"
export * from "./home-tag-based-entry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c6749a",
  null
  
)

export default component.exports